<template>
  <v-dialog v-model="dialogModel" max-width="560">
    <v-card>
      <v-card-title class="text-h6 font-weight-bold">
        Enable Location Access
      </v-card-title>
      <v-card-text>
        <p class="mb-3">
          Location is currently blocked for this site. Update your browser site permissions, then click
          <strong>Enable Location</strong> again.
        </p>

        <h4 class="text-subtitle-1 font-weight-medium mb-2">Chrome / Edge</h4>
        <ol class="mb-3">
          <li>Click the lock icon near the address bar.</li>
          <li>Find <strong>Location</strong> permission.</li>
          <li>Set it to <strong>Allow</strong>.</li>
          <li>Refresh the page.</li>
        </ol>

        <h4 class="text-subtitle-1 font-weight-medium mb-2">Safari (Mac/iPhone)</h4>
        <ol class="mb-0">
          <li>Open browser/app settings for website permissions.</li>
          <li>Find this site under location permissions.</li>
          <li>Change location access to <strong>Allow</strong>.</li>
          <li>Reload the page and retry.</li>
        </ol>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="#f46523" @click="dialogModel = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LocationPermissionDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogModel: {
      get() {
        return this.value;
      },
      set(next) {
        this.$emit("input", next);
      },
    },
  },
};
</script>
